import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import RegApprovePendingList from "./Components/AdminComponents/RegApprovePendingList";
import RegApprovedList from "./Components/AdminComponents/RegApprovedList";
import HomePage from "./Components/HomePage";
import RegFeeForm from "./Components/StudentComponents/RegFeeForm";
import TermsCondition from "./Components/StudentComponents/TermsCondition";
import Dashboard from "./Components/AdminComponents/Dashboard";
import RegPendingList from "./Components/AdminComponents/RegPendingList";


export default function App() {


  return (
 
      <Routes>

        <Route path="/" element={<HomePage />}  />
        <Route path="/terms-condition" element={<TermsCondition />}  />
        <Route path="/student/reg-fee-form" element={<RegFeeForm />}  />

        {/* ========= ADMIN PAGES ========= */}
        <Route path="/admin/dashboard" element={<Dashboard />} />
        <Route path="/admin/pending-reg-fee" element={<RegPendingList />} />
        <Route path="/admin/app-pending-reg-fee" element={<RegApprovePendingList />} />
        <Route path="/admin/app-reg-fee" element={<RegApprovedList />} />

      </Routes>
  ) 
}
